// apps/client/src/components/reports/avsV2/avsV2Format.ts
// Small presentation helpers shared by the Approved vs Settled v2 sections.
// Money stays integer cents until it reaches formatCurrencyShorthand.

import { BUSINESS_TZ } from '../../../utils/businessTime';

/** Empty-cell placeholder. The only place a dash stands alone in this page's copy. */
export const EMPTY = '—';

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/** 'YYYY-MM' (or 'YYYY-MM-DD') to "Sep 2026". Unparseable input is returned as is. */
export function monthLabel(ym: string): string {
  const m = /^(\d{4})-(\d{2})/.exec(ym);
  if (!m) return ym;
  const idx = Number(m[2]) - 1;
  return idx >= 0 && idx < 12 ? `${MONTHS[idx]} ${m[1]}` : ym;
}

export function plural(n: number, one: string, many: string): string {
  return `${n.toLocaleString()} ${n === 1 ? one : many}`;
}

/** Ratio (0.731) to "73.1%". */
export function formatPct(ratio: number | null | undefined): string {
  if (ratio == null || !Number.isFinite(ratio)) return EMPTY;
  return `${(ratio * 100).toFixed(1)}%`;
}

/** ISO-8601 timestamp to "7 Oct 2026, 6:00 am" in Brisbane time. */
export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d
    .toLocaleString('en-AU', {
      timeZone: BUSINESS_TZ,
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    })
    .replace(/\s?(AM|PM)$/i, (s) => s.toLowerCase());
}

/** Today's civil date in Brisbane, 'YYYY-MM-DD' (the follow-up date floor). */
export function todayCivilDate(now: Date = new Date()): string {
  // en-CA formats as YYYY-MM-DD.
  return now.toLocaleDateString('en-CA', { timeZone: BUSINESS_TZ });
}
